import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from '../components/DashboardPage';
import PreviewerStoriesPage from '../components/PreviewerStoriesPage';
import ScenesPage from '../components/ScenesPage';
import PreviewerContentPage from '../components/PreviewerContentPage';
import GenerationScenesPage from '../components/GenerationScenesPage';
import GenerationStoriesPage from '../components/GenerationStoriesPage';
import GenerationContentPage from '../components/GenerationContentPage';
import GenerationQueuePage from '../components/GenerationQueuePage';
import SettingsPage from '../components/SettingsPage';
import ProfilePage from '../components/ProfilePage';
import AIDesignImaginePage from '../components/AIDesignImaginePage';
import AIDesignExpandPage from '../components/AIDesignExpandPage';
import AIDesignUpscalePage from '../components/AIDesignUpscalePage';
import AIStoryPage from '../components/AIStoryPage';
import AIDesignMyGenerationsPage from '../components/AIDesignMyGenerationsPage';
import AIDesignMyFavouritesPage from '../components/AIDesignMyFavouritesPage';
import AIDesignAllGenerationsPage from '../components/AIDesignAllGenerationsPage';
import AIDesignTestPage from '../components/AIDesignTestPage';
import AIDesignMultipleTestPage from '../components/AIDesignMultipleTestPage';
import SnapsAIEditPage from '../components/SnapsAIEditPage';
import SnapsAIEditPage2 from '../components/SnapsAIEditPage2';
import DataEntryPage from '../components/DataEntryPage';
import OrdersPage from '../pages/OrdersPage';
import OrderDetailPage from '../pages/OrderDetailPage';
import OrderCreatePage from '../pages/OrderCreatePage';
import TicketsPage from '../pages/TicketsPage';
import TicketDetailPage from '../pages/TicketDetailPage';
import TrialsPage from '../components/TrialsPage';
import UsersPage from '../pages/UsersPage';
import PrintingsPage from '../components/PrintingsPage';
import PrintVerificationPage from '../components/PrintVerificationPage';
import ExpressPrintingsPage from '../components/ExpressPrintingsPage';
import ExpensesPage from '../pages/ExpensesPage';
import ReportsPage from '../pages/ReportsPage';
// New Accounting Pages
import CommissionsPage from '../pages/CommissionsPage';
import BudgetsPage from '../pages/BudgetsPage';
import TaxesPage from '../pages/TaxesPage';
import FinancialReportsPage from '../pages/FinancialReportsPage';
import AccountingSettingsPage from '../pages/AccountingSettingsPage';
import PaymentsReconciliationPage from '../pages/PaymentsReconciliationPage';
import AccountingSummaryPage from '../pages/AccountingSummaryPage';
import PayoutsPage from '../pages/PayoutsPage';
import OfflinePreviewsPage from '../pages/OfflinePreviewsPage';
import PrintersPage from '../components/PrintersPage';
import AdminSettingsPage from '../pages/AdminSettingsPage';
import RegenerationModelsPage from '../pages/RegenerationModelsPage';
import MontageProfilesPage from '../pages/MontageProfilesPage';

const AppRoutes = ({
  setToastMessage,
  setToastActive,
  isCreateModalOpen,
  setIsCreateModalOpen,
  isCreateSceneModalOpen,
  setIsCreateSceneModalOpen
}) => {
  return (
    <Routes>
      {/* Default redirect to dashboard */}
      <Route path="/dashboard" element={<Navigate to="/" replace />} />

      {/* Dashboard */}
      <Route path="/" element={<DashboardPage />} />

      {/* Previewer Routes */}
      <Route
        path="/previewer/stories"
        element={
          <PreviewerStoriesPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
            isCreateModalOpen={isCreateModalOpen}
            setIsCreateModalOpen={setIsCreateModalOpen}
          />
        }
      />
      <Route
        path="/previewer/scenes"
        element={
          <ScenesPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
            isCreateSceneModalOpen={isCreateSceneModalOpen}
            setIsCreateSceneModalOpen={setIsCreateSceneModalOpen}
          />
        }
      />
      <Route
        path="/previewer/content"
        element={
          <PreviewerContentPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Offline Routes */}
      <Route
        path="/offline/previews"
        element={
          <OfflinePreviewsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/offline/orders"
        element={<OrdersPage fixedSource="offline" />}
      />
      <Route
        path="/offline/generations"
        element={
          <GenerationContentPage
            fixedSource="offline"
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Generation Routes */}
      <Route path="/generation/stories" element={<GenerationStoriesPage />} />
      <Route
        path="/generation/montage-profiles"
        element={
          <MontageProfilesPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route path="/generation/scenes" element={<GenerationScenesPage />} />
      <Route
        path="/generation/content"
        element={
          <GenerationContentPage
            excludeSource="offline"
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/generation/queue"
        element={
          <GenerationQueuePage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* AI Design Routes */}
      <Route
        path="/ai-design/imagine"
        element={
          <AIDesignImaginePage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/expand"
        element={
          <AIDesignExpandPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/upscale"
        element={
          <AIDesignUpscalePage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/test"
        element={
          <AIDesignTestPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/edit"
        element={
          <SnapsAIEditPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/design-pro"
        element={
          <SnapsAIEditPage2
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/test-multiple"
        element={
          <AIDesignMultipleTestPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/story"
        element={<AIStoryPage setToastMessage={setToastMessage} setToastActive={setToastActive} />}
      />
      <Route
        path="/ai-design/my-generations"
        element={
          <AIDesignMyGenerationsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/my-favourites"
        element={
          <AIDesignMyFavouritesPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/ai-design/all-generations"
        element={
          <AIDesignAllGenerationsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Data Entry Routes */}
      <Route
        path="/data-entry"
        element={
          <DataEntryPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Printings Routes */}
      <Route
        path="/printings"
        element={<PrintingsPage />}
      />
      <Route
        path="/printings/premium"
        element={<Navigate to="/printings" replace />}
      />
      <Route
        path="/printings/booklet"
        element={<Navigate to="/printings" replace />}
      />
      <Route
        path="/printings/express"
        element={<ExpressPrintingsPage />}
      />
      <Route
        path="/printings/express/booklet"
        element={<Navigate to="/printings/express" replace />}
      />
      <Route
        path="/printings/verify"
        element={<PrintVerificationPage />}
      />
      <Route
        path="/printings/:printingId/verify"
        element={<PrintVerificationPage />}
      />

      {/* Trials Routes */}
      <Route
        path="/trials"
        element={
          <TrialsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Orders Routes */}
      <Route
        path="/orders"
        element={
          <OrdersPage
            excludeSource="offline"
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/orders/new"
        element={
          <OrderCreatePage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/orders/:orderId"
        element={
          <OrderDetailPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />

      {/* Tickets Routes */}
      <Route
        path="/tickets"
        element={<TicketsPage />}
      />
      <Route
        path="/tickets/:ticketId"
        element={<TicketDetailPage />}
      />

      {/* Users Routes */}
      <Route
        path="/users"
        element={<UsersPage />}
      />

      {/* Printers Routes */}
      <Route
        path="/printers"
        element={
          <PrintersPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      {/* Admin Settings Route */}
      <Route
        path="/admin-settings"
        element={<AdminSettingsPage />}
      />

      {/* Accounting Routes */}
      <Route
        path="/accounting/dashboard"
        element={<Navigate to="/accounting/summary" replace />}
      />
      <Route path="/accounting/summary" element={<AccountingSummaryPage />} />
      <Route path="/accounting/payouts" element={<PayoutsPage />} />
      <Route
        path="/accounting/expenses"
        element={
          <ExpensesPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route
        path="/accounting/reports"
        element={
          <ReportsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      {/* New Accounting Routes */}
      <Route path="/settlements" element={<Navigate to="/accounting/payouts" replace />} />
      <Route path="/commissions" element={<CommissionsPage />} />
      <Route path="/budgets" element={<BudgetsPage />} />
      <Route path="/taxes" element={<TaxesPage />} />
      <Route path="/financial-reports" element={<FinancialReportsPage />} />
      <Route path="/accounting/settings" element={<AccountingSettingsPage />} />
      <Route path="/accounting/payments" element={<PaymentsReconciliationPage />} />

      <Route
        path="/settings"
        element={
          <SettingsPage
            setToastMessage={setToastMessage}
            setToastActive={setToastActive}
          />
        }
      />
      <Route path="/settings/ai-models" element={<RegenerationModelsPage />} />
      <Route path="/profile" element={<ProfilePage />} />

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
